import { render, staticRenderFns } from "./creditCompareWx.vue?vue&type=template&id=49776286"
import script from "./creditCompareWx.vue?vue&type=script&lang=js"
export * from "./creditCompareWx.vue?vue&type=script&lang=js"
import style0 from "./creditCompareWx.vue?vue&type=style&index=0&id=49776286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports